// ============================================================================
// PROCESS PICKER
// ARQUIVO: src/components/common/ProcessPicker.jsx
// RESPONSABILIDADE: Busca + seleção de um processo/caderno (autos_workspaces)
//   pra vincular a outro (Fase F2b — MC51). Reaproveita a casca do
//   FlyoutPanel (MC38) e a lógica de busca já compartilhada em
//   formatters.js (normalizeSearchText/filterWorkspacesBySearch) — mesma
//   busca por CNJ/cliente/apelido já usada na lista "Processos e Casos",
//   sem duplicar.
// ============================================================================
import React, { useMemo, useState } from 'react';
import { FlyoutPanel } from './FlyoutPanel';
import { resolveProcessTitle, filterWorkspacesBySearch } from '../../utils/formatters';

export const ProcessPicker = ({
  open,
  onClose,
  title = 'Vincular Processo',
  workspaces = [],
  excludeWorkspaceId,
  onSelect,
}) => {
  const [search, setSearch] = useState('');

  const results = useMemo(() => {
    const base = (Array.isArray(workspaces) ? workspaces : []).filter(
      (w) => w?.id !== excludeWorkspaceId,
    );
    return filterWorkspacesBySearch(base, search);
  }, [workspaces, search, excludeWorkspaceId]);

  return (
    <FlyoutPanel open={open} onClose={onClose} title={title} zIndexClassName="z-[90]">
      <input
        autoFocus
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Buscar por CNJ, cliente ou apelido..."
        className="w-full px-3 py-2 rounded-lg border border-slate-300 text-sm mb-3 focus:outline-none focus:ring-2 focus:ring-[#C5A059]/40"
      />
      <div className="space-y-1">
        {results.length === 0 ? (
          <div className="text-xs text-slate-400 text-center py-6">
            Nenhum processo encontrado.
          </div>
        ) : (
          results.map((w) => {
            const { title: rowTitle, subtitle } = resolveProcessTitle(w);
            return (
              <button
                key={w.id}
                type="button"
                onClick={() => {
                  onSelect?.(w);
                  onClose?.();
                }}
                className="w-full text-left px-3 py-2 rounded-lg border border-slate-200 hover:border-[#C5A059] hover:bg-[#C5A059]/5 transition-colors"
              >
                <div className="text-sm font-bold text-[#20243B] truncate">{rowTitle}</div>
                <div className="text-xs text-slate-500 truncate">
                  {w?.clientName ? `${w.clientName} · ` : ''}
                  {subtitle}
                </div>
              </button>
            );
          })
        )}
      </div>
    </FlyoutPanel>
  );
};

export default ProcessPicker;
